import * as styled from '../styles/site-footer';

export const SiteFooter = () => (
  <styled.Footer>
    © {new Date().getFullYear()} Kudable. Turn your reputation into bookings.
  </styled.Footer>
);
